import { SUFFIX } from './const'

const middle = (type, params) => ({
	type: SUFFIX + type,
	...params
})

export default middle
